import tagConstants from "constants/Tag";

export const MODEL_TYPE = "Case";
export const TAG_MODEL_TYPE = tagConstants.taggableModels.case;

export const PAGE_TITLE = "Edit Case";
export const BREADCRUMB_LABEL = "Edit";
export const SUCCESS_MESSAGE = "Case updated";
